import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Detects where the continuation token is and returns it. Notice that azure-asyncoperation
 * must be checked first before the other location headers because there are scenarios
 * where both azure-asyncoperation and location could be present in the same response but
 * azure-asyncoperation should be the one to use for polling.
 */
export function getPollingUrl(rawResponse, defaultPath) {
  var _a, _b, _c;

  return (_c = (_b = (_a = getAzureAsyncOperation(rawResponse)) !== null && _a !== void 0 ? _a : getOperationLocation(rawResponse)) !== null && _b !== void 0 ? _b : getLocation(rawResponse)) !== null && _c !== void 0 ? _c : defaultPath;
}

function getLocation(rawResponse) {
  return rawResponse.headers["location"];
}

function getOperationLocation(rawResponse) {
  return rawResponse.headers["operation-location"];
}

function getAzureAsyncOperation(rawResponse) {
  return rawResponse.headers["azure-asyncoperation"];
}

function findResourceLocation(requestMethod, rawResponse, requestPath) {
  switch (requestMethod) {
    case "PUT":
      {
        return requestPath;
      }

    case "POST":
    case "PATCH":
      {
        return getLocation(rawResponse);
      }

    default:
      {
        return undefined;
      }
  }
}

export function inferLroMode(requestPath, requestMethod, rawResponse) {
  if (getAzureAsyncOperation(rawResponse) !== undefined || getOperationLocation(rawResponse) !== undefined) {
    return {
      mode: "Location",
      resourceLocation: findResourceLocation(requestMethod, rawResponse, requestPath)
    };
  } else if (getLocation(rawResponse) !== undefined) {
    return {
      mode: "Location"
    };
  } else if (["PUT", "PATCH"].includes(requestMethod)) {
    return {
      mode: "Body"
    };
  }

  return {};
}

var SimpleRestError = /*#__PURE__*/function (_Error) {
  _inherits(SimpleRestError, _Error);

  function SimpleRestError(message, statusCode) {
    var _this;

    _classCallCheck(this, SimpleRestError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleRestError).call(this, message));
    _this.name = "RestError";
    _this.statusCode = statusCode;
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this)), SimpleRestError.prototype);
    return _this;
  }

  return SimpleRestError;
}(_wrapNativeSuper(Error));

export function isUnexpectedInitialResponse(rawResponse) {
  var code = rawResponse.statusCode;

  if (![203, 204, 202, 201, 200, 500].includes(code)) {
    throw new SimpleRestError("Received unexpected HTTP status code ".concat(code, " in the initial response. This may indicate a server issue."), code);
  }

  return false;
}
export function isUnexpectedPollingResponse(rawResponse) {
  var code = rawResponse.statusCode;

  if (![202, 201, 200, 500].includes(code)) {
    throw new SimpleRestError("Received unexpected HTTP status code ".concat(code, " while polling. This may indicate a server issue."), code);
  }

  return false;
}